import React, { useContext } from "react";
import "./AppFrame.css";
import { AppStateContext } from "../../containers/App";

export interface AppFrameProps {
  /** Content for the left-hand side of the header. */
  headerLeftContent?: React.ReactNode | React.ReactNodeArray;
  /** Content for the right-hand side of the header. */
  headerRightContent?: React.ReactNode | React.ReactNodeArray;
  /** Content for the footer. */
  footerContent?: React.ReactNode | React.ReactNodeArray;
  /** The content to display within the main area of the app. */
  children?: React.ReactNode | React.ReactNodeArray;
}

export default function AppFrame({
  headerLeftContent,
  headerRightContent,
  footerContent,
  children
}: AppFrameProps) {
  const [appState] = useContext(AppStateContext);
  const config = appState.config;

  return (
    <>
      <header className="app-header">
        <div className="app-header-left">
          {!!headerLeftContent && headerLeftContent}
        </div>
        <div className="app-header-center">
          <h1 className="app-logo">
            {config.brand} {config.name}
          </h1>
        </div>
        <div className="app-header-right">
          {!!headerRightContent && headerRightContent}
        </div>
      </header>
      <main className="app-main">{!!children && children}</main>
      {!!footerContent && (
        <footer className="app-footer">{footerContent}</footer>
      )}
    </>
  );
}
